export { SaloonCarIcon } from "./car-shape-saloon";
